import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import api from '../services/api';

const SorteioManuntencao = ({ route, navigation }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [cartelas, setCartelas] = useState([]);

  const handleObterCartelasRepetidas = useCallback(async () => {
    const sorteio_id = route.params.sorteio_id;
    const { data } = await api.get(`sorteios/${sorteio_id}/repetidas`);

    const cartelasRepetidas = data.flat();
    setCartelas(cartelasRepetidas);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      setIsLoading(true);
      handleObterCartelasRepetidas();
    });

    return unsubscribe;
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1, paddingBottom: 200 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <View>
            {isLoading ? (
              <View
                style={{
                  backgroundColor: '#fff',
                  padding: 10,
                  marginTop: 10,
                  borderRadius: 5,
                  alignItems: 'center',
                }}
              >
                <Image
                  style={{ height: 32, width: 32 }}
                  source={require('../assets/loading.gif')}
                />
              </View>
            ) : cartelas.length > 0 ? (
              cartelas.map((cartela, index) => (
                <View
                  key={cartela.id || index}
                  style={{
                    backgroundColor: '#fff',
                    padding: 10,
                    marginTop: 10,
                    borderRadius: 5,
                    borderLeftWidth: 4,
                    borderLeftColor: '#e74c3c',
                  }}
                >
                  <View style={{ marginBottom: 10 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#e74c3c',
                      }}
                    >
                      Cartela ID: {cartela.id}
                    </Text>
                    {cartela.cliente && (
                      <Text style={{ fontSize: 12 }}>
                        Cliente: {cartela.cliente.nome} -{' '}
                        {cartela.cliente.whatsapp}
                      </Text>
                    )}
                  </View>

                  <View style={{ flexDirection: 'row' }}>
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                      }}
                    >
                      {cartela.numeros.map((numero, numIndex) => (
                        <Text
                          key={numIndex}
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            borderWidth: 1,
                            borderColor: '#95a5a6',
                            padding: 5,
                            borderRadius: 10,
                            margin: 2,
                            fontSize: 12,
                            minWidth: 40,
                          }}
                        >
                          {numero}
                        </Text>
                      ))}
                    </View>
                  </View>
                </View>
              ))
            ) : (
              <View>
                <Text style={{ textAlign: 'center' }}>
                  Nenhuma cartela repetida
                </Text>
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default SorteioManuntencao;
